import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { portfolioModelo } from '@constants/URL'
import { DIC_RESTR_SIMULADOR } from '@/src/constants/Text'

const OFFICE_ID_DEFAULT = 1

class APIPortfolioPortfolioModels extends APITemplate {
  async carregar(forceUpdate = false, { is_client_compliance } = {}) {
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['portfolio/portfolioModelsLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['portfolio/portfolioModels']
      }
    }

    if (store.getters['portfolio/portfolioModelsLoading']) {
      return store.getters['portfolio/portfolioModels']
    }

    store.dispatch('portfolio/setPortfolioModelsLoading', true)

    let url = store.getters['user/currentUser'].IS_GESTOR
      ? portfolioModelo.manage
      : portfolioModelo.read

    if (is_client_compliance) {
      url = url + `?is_client_compliance=true`
    }

    const r = await con.get(url)

    if (r && r.status === 200) {
      store.dispatch('portfolio/setPortfolioModels', r.value || [])
    } else {
      store.dispatch('portfolio/setPortfolioModels', [])
    }

    store.dispatch('portfolio/setPortfolioModelsLoading', false)

    return r || {}
  }

  removeToPost(data) {
    const fields = ['nome', 'ativos', ...Object.values(DIC_RESTR_SIMULADOR)]

    const newData = {}
    fields.forEach((field) => {
      if (data.hasOwnProperty(field)) {
        newData[field] = data[field]
      }
    })

    return newData
  }

  async saveCompliancePointsProfile(models) {
    const success = []
    const erros = []

    await Promise.all(
      models.map(async (model) => {
        const data = {
          dados: JSON.stringify({
            nome: model.nome,
            pontuacao_minima: model.pontuacao_min,
            pontuacao_maxima: model.pontuacao_max,
          }),
          id_portfolio: model.id,
        }

        if (model.id_escritorio === OFFICE_ID_DEFAULT) {
          const dataPost = { dados: JSON.stringify(this.removeToPost(model)) }

          await con.post(portfolioModelo.manage, dataPost)
        }

        const r = await con.put(portfolioModelo.manage, data)

        if (r && r.status === 200) {
          success.push(r.value || {})
        } else {
          erros.push({ model, error: r.message || 'Erro desconhecido' })
        }

        return r
      })
    )

    if (erros.length) {
      return {
        status: 400,
        message: 'Alguns modelos não foram salvos corretamente.',
        success,
        erros,
      }
    }

    return {
      status: 200,
      message: 'Todos os modelos foram salvos com sucesso.',
      success,
    }
  }

  // async salvar({ id }) {
  //   const dado = {
  //     id,
  //   }
  //
  //   const data = {
  //     data: JSON.stringify(dado),
  //   }
  //
  //   let r
  //   if (id > 0) {
  //     r = await con.put(dev.espelho, data)
  //   } else {
  //     r = await con.post(dev.espelho, data)
  //   }
  //
  //   if (r && r.status === 200) {
  //     store.dispatch('portfolio/addPortfolioModels', r.value[0] || r.value || {})
  //   } else {
  //     store.dispatch('portfolio/addPortfolioModels', {})
  //   }
  //
  //   return r || {}
  // }
  //
  // async remover({ id }) {
  //   if (!id) {
  //     return {
  //       status: 404,
  //       message: 'Item não encontrado.',
  //     }
  //   }
  //
  //   store.dispatch('portfolio/setPortfolioModelsLoading', true)
  //
  //   const r = await con.delet(dev.espelho + `/${id}`)
  //
  //   store.dispatch('portfolio/setPortfolioModelsLoading', false)
  //
  //   if (r && r.status === 200) {
  //     this.carregar(true)
  //   }
  //
  //   return r || {}
  // }
}

const apiPortfolioPortfolioModels = new APIPortfolioPortfolioModels()
export { apiPortfolioPortfolioModels }
